/**
 * Regex to check dutch housenumber additions
 * @type {RegExp}
 */

const houseNumberAddition = /^[a-zA-Z]+$/

export default houseNumberAddition
